import type { ReactNode } from 'react'

import { Stack } from '@mui/material'

type Props = {
  width: number
  children?: ReactNode
  testid?: string
  rightBorder?: boolean
}

export function FormColumn(props: Props) {
  return (
    <Stack
      position="relative"
      direction="column"
      height="100%"
      maxHeight="100%"
      flexShrink={0}
      width={props.width}
      borderRight={props.rightBorder ? theme => `1px solid ${theme.palette.divider}` : undefined}
      alignItems="center"
      data-testid={props.testid}
    >
      {props.children}
    </Stack>
  )
}
